import { ComponentFactoryResolver, Directive, Input, ViewContainerRef } from '@angular/core';
import { TimelineSection } from '../_models/timeline-models/section-listing.model';
import { LearningSectionRendererHelperService } from '../_helpers/learning-section-renderer-helper/learning-section-renderer-helper.service';
import { BaseLearningSectionComponent } from '../shared/learning-section/base-learning-section/base-learning-section.component';
import { TimelineSectionStudentInfo } from '../_models/timeline-models/timeline-section-student-info.model';

@Directive({
    selector: '[timelineSectionSelector]',
    standalone: false
})
export class TimelineDirective {

  @Input() timelineSectionSelector: TimelineSection;
  @Input() editMode: boolean;

  constructor(
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private learningSectionRendererHelperService: LearningSectionRendererHelperService) {
  }

  public renderSection(timelineSection: TimelineSection, edit: boolean, placementId: number, students: TimelineSectionStudentInfo[], subject: string, minSectionDate: Date) : BaseLearningSectionComponent {
    this.viewContainerRef.clear();
    const sectionToRender = this.learningSectionRendererHelperService.getLearningSection(timelineSection.sectionType);
    const component = sectionToRender.component;
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
    const instance = this.viewContainerRef.createComponent(componentFactory).instance as BaseLearningSectionComponent;
    instance.editMode = edit;
    instance.placementId = placementId;
    instance.students = students;
    instance.timelineSection = timelineSection;
    instance.subject = subject;
    instance.minSectionDate = minSectionDate;
    // may need to strongly type from base class model to component specific
    return instance;
  }
}
